import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import ApplicationContext from '../../context/ApplicationContext';
import AnimatedImage from '../Animations/AnimatedImage';
import DocumentsMain from '../../pages/Documents/DocumentsMain';
import SignatureMain from '../../pages/Documents/DocumentLoad/Signature/SignatureMain';

function Layout(props) {
    const { facilityData, handlePage, selectedLanguage, currentPage, sessionData, setLoading, isSignatureUploading } = useContext(ApplicationContext);

    return (
        <div className='relative pt-[43px] outer-bg pb-[50px] lg:m-auto lg:w-1/2'>
            <div className='flex justify-between'>
                <AnimatedImage testid="logo" url={facilityData?.facility_logo} alt="logo" className="absolute top-0 max-h-[42px] py-[5px] ml-[12px] rotate-45" />
                {currentPage !== 'choose_language' && currentPage !== 'welcome' && currentPage !== 'nameVerify' && currentPage !== 'dobVerify' && 
                    <p onClick={() => {setLoading(true); handlePage('choose_language', '', '', '', '', '', sessionData.document_session)}} 
                        className='flex text-white text-base font-semibold uppercase absolute top-[13px] right-[12px]'>{selectedLanguage}<img className='ml-2' src="/images/white-flag.svg" alt="language" /></p>}
            </div>
            {currentPage === 'documents' && <DocumentsMain />}
            {currentPage === 'signature' && <SignatureMain />}
            <div className={`rounded-t-2xl bg-[#F2F2F2] mx-[8px]`}>
                <Outlet />
            </div>
            <motion.footer
                // initial={{ opacity: 0, scale: 0.4 }}
                // animate={{ opacity: 1, scale: 1 }}
                exit="exit"
                className='bg-black h-auto w-full py-[7px] px-[12px] flex justify-end fixed bottom-0 z-[9] lg:w-[50%]'
                transition={{ duration: 0.6, delay: 0.8, type: "spring" }}
            >
                <img src="/images/gbs.png" alt="gbs" />
            </motion.footer>
        </div>
    );
}

export default Layout;